import PropTypes from 'prop-types';
import React from 'react';
import Icon, { Icons } from '../Icon/Icon';
import './AdaptiveButton.scss';

const AdaptiveButton = ({ iconSize = 24, icon = null, onClick = () => {}, children }) => {
	return (
		<div className='AdaptiveButton' onClick={onClick}>
			{icon && <Icon type={Icons[icon]} width={iconSize} height={iconSize} />}
			{children}
		</div>
	);
};

AdaptiveButton.propTypes = {
	iconSize: PropTypes.number,
	icon: PropTypes.string,
	onClick: PropTypes.func,
	children: PropTypes.node,
};

export default AdaptiveButton;
